import { lazy, Suspense } from 'react'
import Loader from '../custom/loader/main';

const Main = lazy(() => import('../components/approval/viewResults/main'));

const ViewResults = () => {
  return (
    <Suspense fallback={<Loader/>}>
      <Main/>
    </Suspense>
  )
}

export default ViewResults;